export const ACTIVITY_LOG_GRID_RECORD_MESSAGE = 'No records to display at this time.';

export const VIEW_GRID_COLUMNS = new Set([
  {
    dataName: 'appSection',
    text: 'App Section',
    sortable: true,
    isSorted: 0,
    headerWidth: 85,
    isHeaderTruncated: true,
  },
  {
    dataName: 'referenceId',
    text: 'Ref ID',
    sortable: true,
    isSorted: 0,
    headerWidth: 100,
    isHeaderTruncated: true,
    cellType: 'custom',
  },
  {
    dataName: 'userName',
    text: 'User',
    sortable: true,
    isSorted: 0,
    headerWidth: 220,
    isHeaderTruncated: true,
  },
  {
    dataName: 'activity',
    text: 'Activity',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'description',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    headerWidth: 190,
    isHeaderTruncated: true,
    cellType: 'custom',
  },
  {
    dataName: 'dateTime',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
]);

export const LAST_DAYS_VIEW_DROPDOWN = [
  {
    label: 'Last 7 Days',
    value: '7',
  },
  {
    label: 'Last 14 Days',
    value: '14',
  },
  {
    label: 'Last 30 Days',
    value: '30',
  },
];

export enum ActionTypesActivityLog {
  SET_ACTIVITY_LOG_DATA = 'SET_ACTIVITY_LOG_DATA',
  SET_ACTIVITY_LOG_DAYS_VIEW = 'SET_ACTIVITY_LOG_DAYS_VIEW',
  TOGGLE_IS_ACTIVITY_LOG_DATA_LOADING = 'TOGGLE_IS_ACTIVITY_LOG_DATA_LOADING',
}
